// src/plugins/coloris.plugin.js
import Coloris from '@melloware/coloris'
import '@melloware/coloris/dist/coloris.css'

let installed = false

export default {
  install() {
    if (installed || typeof window === 'undefined') return
    installed = true

    Coloris.init?.()
  },
}
